import {AuthenticatedUserContext} from "components/src/context/AuthenticatedUserContextProvider";
import {useContext} from 'react'

export function useAuthenticatedUserContext()
{
    const context = useContext(AuthenticatedUserContext);

    if (!context) {
        throw new Error(
            "useAuthenticatedUserContext must be used within the scope of AuthenticatedUserContextProvider"
        );
    }

    return context;
}